import UserInfoPage from '@/views/profile/UserInfoPage'

export default function UserInfoScreen() {
  return <UserInfoPage />
}
